import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '../../containers/Full'

import store from '../store'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    linkActiveClass: 'open active',
    scrollBehavior (to, from, savedPosition) {
        // savedPosition is only available for popstate navigations.
        if (savedPosition) return savedPosition

        // if the returned position is falsy or an empty object,
        // will retain current scroll position.
        if (to.params.savePosition) return {}

        // scroll to anchor by returning the selector
        if (to.hash) {
            return {selector: to.hash}
        }

        // scroll to top by default
        return {x: 0, y: 0}
    },
    routes: [
        {
            path: '*',
            component: Full,
            beforeEnter: (to, from, next) => {
                if (!store.getters.getInit) {
                    store.dispatch('init', laravel);
                    store.dispatch('account/login').then((user) => {
                      const queryParams = to.query;
                      if(!user.dealer){
                        next({name: 'Registration', query: queryParams});
                      } else {
                        store.dispatch('notification/loadNotifications')
                            .then(() => next(to));
                      }
                    });
                }
            },
            meta: {
                authName: "dealer",
            }
        }
    ]
});

export default router;
